




















import { Component, Prop, Vue } from "vue-property-decorator";
import { TimelineI } from "@/models/admin/ProposalModel";

@Component
/**
 * Show a skeleton for the dashboard
 */
export default class DashboardSkeleton extends Vue {
  /**
   * A list of timeline items
   */
  @Prop({ required: true }) readonly timeline!: TimelineI[];
}
